import React from 'react';
import { Box } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';

import { wsrColors } from './wsrTokens';

interface WsrEmptyPageProps {
  pageNum: number;
  title: string;
}

const WsrEmptyPage: React.FC<WsrEmptyPageProps> = ({ pageNum, title }) => (
  <Box
    sx={{
      background: '#fff',
      border: `1px dashed ${wsrColors.slate300}`,
      borderRadius: '12px',
      padding: '80px 24px',
      textAlign: 'center',
      color: wsrColors.slate400,
    }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: '12px',
        margin: '0 auto 16px',
        background: wsrColors.slate100,
        display: 'grid',
        placeItems: 'center',
        color: wsrColors.slate400,
      }}
    >
      <DescriptionIcon sx={{ fontSize: 26 }} />
    </Box>
    <Box
      sx={{
        fontSize: 13,
        fontWeight: 600,
        color: wsrColors.slate500,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
      }}
    >
      Page {String(pageNum).padStart(2, '0')}
    </Box>
    <Box sx={{ marginTop: '6px', fontSize: 22, fontWeight: 600, color: wsrColors.slate700 }}>
      {title}
    </Box>
    <Box sx={{ marginTop: '8px', fontSize: 14 }}>
      Content for this section will be added.
    </Box>
  </Box>
);

export default WsrEmptyPage;
